//--------------------------------------------------
// imported classes
//--------------------------------------------------
const EventDispatcher = require('@/tbs/event/EventDispatcher')
const ServiceAgent = require('@/tbs/service/ServiceAgent')
const GlobalFunc = require('@/tbs/util/GlobalFunc')

/**
 * The SceneBridge class works as the bridge
 * connected the scene instance with the business logic.
 * It provides the easy and flexible approaches to do interact.
 * By bridge, the business logic layer could access the authorized
 * properties and methods.
 * By bridge, the business logic layer even could use high level APIs 
 * to perform well.
 */
const tbs_core_SceneBridge = function(scene) {
    /**
     * The scene instance
     */
    this._scene = scene
    /**
     * The dispatcher instance
     */
    this._dispatcher = new EventDispatcher
    /**
     * The service agent instance
     */
    this._service = new ServiceAgent
}

//--------------------------------------------------
// prototype
//--------------------------------------------------
tbs_core_SceneBridge.prototype = {
    //--------------------------------------------------
    // api
    //--------------------------------------------------
    /**
     * @api
     * Validate the scene is collection type or not.
     * Check the route name contains 'List' and 'Batch'.
     * @return The boolean result
     */
    isCollection: function() {
        // console.log('isCollection')
        return this.isList() || this.isBatch()
    },
     /**
     * @api
     * Validate the scene is list type or not.
     * Check the route name contains 'List' string or not.
     * @return The boolean result
     */
    isList: function() {
        // console.log('isCollection')
        return this._scene.$route.name.indexOf('List') > -1
    },
    /**
     * @api
     * Validate the scene is create type or not.
     * Check the route name contains 'Create' string or not.
     * @return The boolean result
     */
    isCreate: function() {
        // console.log('isCreate')
        return this._scene.$route.name.indexOf('Create') > -1
    },
    /**
     * @api
     * Validate the scene is edit type or not.
     * Check the route name contains 'Edit' string or not.
     * @return The boolean result
     */
    isEdit: function() {
        // console.log('isEdit')
        return this._scene.$route.name.indexOf('Edit') > -1
    },
    /**
     * @api
     * Validate the scene is detail type or not.
     * Check the route name contains 'Detail' string or not.
     * @return The boolean result
     */
    isDetail: function() {
        // console.log('isDetail')
        return this._scene.$route.name.indexOf('Detail') > -1
    },
    /**
     * @api
     * Validate the scene is manager type or not.
     * Check the route name contains 'Manager' string or not.
     * @return The boolean result
     */
    isManage: function() {
        // console.log('isManage')
        return this._scene.$route.name.indexOf('Manage') > -1
    },
    /**
     * @api
     * Validate the scene is batch type or not.
     * Check the route name contains 'Detail' string or not.
     * @return The boolean result
     */
    isBatch: function() {
        // console.log('isBatch')
        return this._scene.$route.name.indexOf('Batch') > -1
    },
    /**
     * @api
     * History back.
     */
    back: function(num) {
        num = num || -1
        this._scene.$router.go(num)
    },
    triggerRouteBack: function() {
        this._scene.onBackBtnClick()
    },
    goToScene: function(name, params, query, isReplace) {
        console.log('goToScene', name, params, query, isReplace)
        if (isReplace) {
            this._scene.$router.replace({name: name, params: params, query: query})
        }
        else {
            this._scene.$router.push({name: name, params: params, query: query})
        }
    },
    goToPath: function(path, query) {
        console.log('goToPath', path, query)
        this._scene.$router.push({path: path, query: query})
    },
    goToUrl: function(url) {
        location.href = url
    },
    replaceQuery: function(query) {
        console.log('replaceQuery', query)
        let href = location.href
        const queryIndex = href.indexOf('?')
        if (queryIndex > -1) {
            href = href.substr(0, queryIndex)
        }
        let queryString = ''
        for (let p in query) {
            queryString += '&' + p + '=' + encodeURIComponent(query[p])
        }
        if (queryString) {
            queryString = queryString.replace('&', '?')
        }
        console.log('@fullPath', href + queryString)
        history.replaceState(null, '', href + queryString)
    },
    /**
     * @api
     * Get the route params object with the given property.
     * If property is null, return the whole params object.
     * If property is given, return the property value.
     */
    getRouteParam: function(prop) {
        if (prop == null) {
            return this._scene.$route.params
        }
        else {
            return this._scene.$route.params[prop]
        }
    },
    getRouteQuery: function(prop) {
        if (prop == null) {
            return this._scene.$route.query
        }
        else {
            return this._scene.$route.query[prop]
        }
    },
    getRouteName: function() {
        return this._scene.$route.name
    },
    getRoutePath: function() {
        return this._scene.$route.path
    },
    title: function(value) {
        if (arguments.length > 0) {
            this._scene.updateTitle(value)
        }
        else {
            return this._scene.navBarTitle
        }
    },
    callResourceInstance: function(type, options, isBulk) {
        if (isBulk) {
            this._service.bulkCall(type, options)
        }
        else {
            this._service.call(type, options)
        }
    },
    addResourceListener: function(type, listener) {
        this._service.addEventListener(type, listener)
    },
    removeResourceListener: function(type, listener) {
        this._service.removeEventListener(type, listener)
    },
    refresh: function() {
        this._scene.creationComplete()
    },
    reload: function() {
        location.reload()
    },
    getToken: function() {
        return GlobalFunc.getCookie('passport')
    }
}

module.exports = tbs_core_SceneBridge